import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { news, newsCategories } from "@/mocks/news";
import useMockLoading from "@/hooks/useMockLoading";
import usePageMeta from "@/hooks/usePageMeta";
import NewsCard from "@/components/feature/NewsCard";
import { NewsCardSkeleton } from "@/components/base/Skeleton";

const PAGE_SIZE = 6;

export default function News() {
  const loading = useMockLoading(500);
  usePageMeta(
    "新闻资讯 - 51每日大赛",
    "51每日大赛新闻资讯频道，汇集赛事新闻报道、选手动态、战报速递与专题解读，第一时间掌握体育赛事最新资讯。",
    "体育新闻,赛事资讯,战报速递,选手动态,51每日大赛",
  );
  const [active, setActive] = useState("全部");
  const [visible, setVisible] = useState(PAGE_SIZE);

  useEffect(() => {
    setVisible(PAGE_SIZE);
  }, [active]);

  const sorted = useMemo(() => [...news].sort((a, b) => (a.date < b.date ? 1 : -1)), []);

  const filtered = active === "全部" ? sorted : sorted.filter((n) => n.category === active);
  const shown = filtered.slice(0, visible);

  return (
    <div className="w-full">
      <div className="w-full bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-8 md:py-10">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-foreground-800">新闻资讯</span>
          </nav>
          <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">新闻资讯</h1>
          <p className="mt-2 text-sm text-foreground-600 max-w-3xl leading-relaxed">
            汇集赛事新闻报道、选手动态、战报速递与专题解读，第一时间掌握体育赛事的最新资讯。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-6 md:py-8">
        <div className="flex flex-wrap items-center gap-2 mb-6">
          {newsCategories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setActive(c)}
              className={`px-3 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 border border-background-200 text-foreground-700 hover:border-primary-300"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {Array.from({ length: 6 }).map((_, i) => (
              <NewsCardSkeleton key={i} />
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-newspaper-line text-4xl text-foreground-300" />
            <p className="mt-3 text-sm text-foreground-600">暂无新闻内容，敬请关注</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {shown.map((n) => (
                <NewsCard key={n.id} item={n} />
              ))}
            </div>
            {visible < filtered.length ? (
              <div className="flex justify-center mt-10">
                <button
                  type="button"
                  onClick={() => setVisible((v) => v + PAGE_SIZE)}
                  className="h-10 px-6 rounded-md border border-background-300 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  加载更多
                </button>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}